<template>
    <table class="table table-condensed">
    	<tr>
    		<th>{{ $t('programme') }}</th>
    		<td v-for="(datum, i) in targetsData" :key="i">
    			<!-- programme dropdown -->
    			<select class="form-control" v-model="datum.programme_id">
    				<option value="0">{{ $t("any") }}</option>
    				<option v-for="programme in $config.getValue('programmes')" :value="programme.Id" :key="programme.Id">{{ programme.Name }}</option>
    			</select>
    		</td>
    		<td>
    			<button class="btn btn-success" @click="addTarget">{{ $t("add") }}</button>
    		</td>
    	</tr>
    	<tr>
    		<th>{{ $t('year') }}</th>
    		<td v-for="(datum, i) in targetsData" :key="i">
    			<!-- year dropdown -->
    			<select class="form-control" v-model="datum.yeargroup_id">
    				<option></option>
    				<template v-for="(programme) in $config.getValue('programmes')">
    					<template v-if="programme.Id == datum.programme_id">
							<option v-for="year in parseInt(programme.CourseLengthYears)+1" :key="year" :value="year">
								<template v-if="(year == parseInt(programme.CourseLengthYears)+1)">{{ $t("graduated") }}</template>
								<template v-else>{{ year }}</template>
							</option>
    					</template>
    				</template>
    			</select>
    		</td>
    		<td><!-- add btn col --></td>
    	</tr>
    	<tr>
    		<th>{{ $t('term') }}</th>
    		<td v-for="(datum, i) in targetsData" :key="i">
    			<!-- term dropdown -->
    			<select class="form-control" v-model="datum.schoolterm_id">
    				<option value="0">{{ $t("any") }}</option>
    				<template v-for="term in $config.getValue('terms')">
    					<template v-if="(datum.programme_id == '0' || term.programme_id == datum.programme_id) && (!datum.yeargroup_id || term.schoolyear_id == datum.yeargroup_id)">
							<option :value="term.schoolterm_id" :key="term.schoolterm_id">
								{{ $config.getProgrammeNameById(term.programme_id) }} {{ term.schoolterm_title }}
							</option>
	    				</template>
    				</template>
    			</select>
    		</td>
    		<td><!-- add btn col --></td>
    	</tr>
    	<tr v-for="(property, i) in selectedProperties" :key="i">
    		<td>{{ propertyName(property) }}</td>
    		<td v-for="(datum, i) in targetsData" :key="i">
    			<input type="text" class="form-control" v-model="datum.reportdataelementtarget_data[propertyName(property)]" />
    		</td>
    		<td><!-- add btn col --></td>
    	</tr>

		<!-- remove target row -->
		<tr>
			<td></td>
			<td v-for="(datum, i) in targetsData" :key="i">
				<button class="btn btn-danger" @click="removeTarget(i, datum)">{{ $t("remove") }}</button>
			</td>
			<td><!-- add btn col --></td>
		</tr>

    </table>
</template>

<script>
export default {
	name: 'DataElementTargets',
	props: ['targetsData', 'selectedProperties', 'dataelement'],
	data() {
		return {
		};
	},
	watch: {

	},
	mounted() {

	},
	methods: {
		propertyName(property) {
	        const parts = property.split('=');
	        return parts[0];
		},

		save(dataelement_id) {

			// make sure all targets have a dataelement id
			for(let datum of this.targetsData) {
				datum.reportdataelement_id = dataelement_id;
			}

            const url = `${this.$settings.APIBaseURL}/reporting/alldata/savetargets`;
            const data = {
            	targetsdata: this.targetsData
            }
            this.$cfetch(url, {
                method: "post",
                data
            })
            .then(json => {
            	if (json.status == 'SUCCESS') {
            		this.$log.info.call(this, 'targets saved');
            	}
            }).catch(error => {
                this.$log.error.call(this, error);
            });
		},

		addTarget() {
			this.$set(this.targetsData, this.targetsData.length, {
				programme_id: '0',
				schoolterm_id: '0',
				yeargroup_id: null,
				reportdataelement_id: this.dataelement.id,
				reportdataelementtarget_data: {}
			});
		},

		removeTarget(index, target) {
			if(target.reportdataelementtarget_id) {
	            const url = `${this.$settings.APIBaseURL}/reporting/alldata/removetarget`;
	            const data = {
	            	targetid: target.reportdataelementtarget_id
	            }

	            this.$cfetch(url, {
	                method: "post",
	                data
	            })
	            .then(json => {
	            	this.$log.info.call(this, json);
	            }).catch(error => {
	                this.$log.error.call(this, error);
	            });
			}
			this.$delete(this.targetsData, index);
		}
	},
	computed: {

	}
};
</script>
